// @flow
import React from 'react';
import { StyleSheet, Text } from 'react-native';

type Props = {
    children: any,
    style: any,
}

const styles = StyleSheet.create({
    text: {
        fontFamily: 'Open Sans',
        fontWeight: 300,
    },
});

const CustomText = (props: Props) => {
    const { children, style } = props;
    return (
        <Text style={[styles.text, style]}>
            {children}
        </Text>
    );
};

export default CustomText;
